module.exports = __webpack_public_path__ + "public/8c0219a27234b6194042a4ebcb720056.woff";